module.exports = __webpack_public_path__ + "img/nut-fill.2e6cd6a1.svg";